import {Component, OnInit, ViewChild} from '@angular/core';
import {Asset} from '../../../model/Asset';
import {MatDialog, MatPaginator, Sort} from '@angular/material';
import {FileuploadService} from '../../../service/http/fileupload.service';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {merge, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import {environment} from '../../../../environments/environment';
import {AcceptDeclineDialogComponent} from '../../../dialog/accept-decline-dialog/accept-decline-dialog.component';
import {MessageDialogComponent} from '../../../dialog/message-dialog/message-dialog.component';

@Component({
  selector: 'app-workflow-app-assets-hotspot-cover',
  templateUrl: './workflow-app-assets-hotspot-cover.component.html',
  styleUrls: ['./workflow-app-assets-hotspot-cover.component.css']
})
export class WorkflowAppAssetsHotspotCoverComponent implements OnInit {

  urlHotspotCoverAssetUpload: string = '/upload/asset/hotspot-cover';

  displayedColumns: string[] = ['name', 'type', 'date', 'size'];
  data: Asset[] = [];
  resultsLength = 0;
  isLoadingResults = true;
  currentPackageIdGlobal: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('file') file;

  constructor(private uploadService: FileuploadService,
              private http: HttpClient,
              public dialog: MatDialog,
              private translate: TranslateService) { }

  ngOnInit() {
    let currentPackageId = sessionStorage.getItem('currentPackageId');
    if(currentPackageId !== null) {
      this.urlHotspotCoverAssetUpload += '/' + currentPackageId;
      this.currentPackageIdGlobal = currentPackageId;
    }

    this.loadTableData();
  }

  loadTableData() {

    merge(this.paginator.page)
      .pipe(
        startWith([]),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.uploadService.fetchAppAssetHotspotCover(this.currentPackageIdGlobal);
        }),
        map(data => {
          this.isLoadingResults = false;
          this.resultsLength = 1;
          return data;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  addHotspotCoverAsset() {
    this.file.nativeElement.click();
  }

  onHotspotCoverAssetAdded() {

    let file = this.file.nativeElement.files[0];
    let ext = file.name.split(".").pop();

    if(ext == 'png') {

      this.http.get<Asset[]>(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCoverAssetUpload).subscribe(data => {

        if(data.length == 0) {
          const formData: FormData = new FormData();
          formData.append('file', file, 'hotspot_cover.png');

          this.isLoadingResults = true;

          this.http.post<Asset[]>(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCoverAssetUpload, formData).subscribe(data => {
            this.isLoadingResults = false;
            this.data = data;
          });
        } else {

          const dialogRef = this.dialog.open(AcceptDeclineDialogComponent, {
            width: '250px',
            data: {
              title: this.translate.instant('DIALOG.REPLACE_HOTSPOT_COVER_ASSET_ACCEPT_DECLINE_DIALOG.TITLE'),
              message: this.translate.instant('DIALOG.REPLACE_HOTSPOT_COVER_ASSET_ACCEPT_DECLINE_DIALOG.MESSAGE'),
              icon: {
                add: false,
                name: ''
              }
            }});

          dialogRef.afterClosed().subscribe(result => {
            if(result == true) {
              const formData: FormData = new FormData();
              formData.append('file', file, 'hotspot_cover.png');
              this.isLoadingResults = true;

              this.http.post<Asset[]>(`${environment.packagesManagerBackendUrl}` + this.urlHotspotCoverAssetUpload, formData).subscribe(data => {
                this.isLoadingResults = false;
                this.data = data;
              });
            }
          });
        }
      });

    } else {
      this.openAlarm(ext, 'Wrong File Format!', 'Please provide an png file:', 'identified ');
    }
  }

  openAlarm(type: string, title: string, message: string, secondMsg: string) {

    this.dialog.open(MessageDialogComponent, {
      data: {
        type: type,
        title: this.translate.instant('DIALOG.NO_HOTSPOT_COVER_ASSET_CHOOSEN_DIALOG.TITLE'),
        message: this.translate.instant('DIALOG.NO_HOTSPOT_COVER_ASSET_CHOOSEN_DIALOG.MESSAGE'),
        secondMsg: this.translate.instant('DIALOG.NO_HOTSPOT_COVER_ASSET_CHOOSEN_DIALOG.SECOND_MESSAGE')
      }
    });
  }

  sortData(sort: Sort) {
    const data = this.data.slice();
    if (!sort.active || sort.direction === '') {
      this.data = data;
      return;
    }

    this.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name': return this.compare(a.name, b.name, isAsc);
        case 'type': return this.compare(a.type, b.type, isAsc);
        case 'size': return this.compare(a.size, b.size, isAsc);
        case 'date': return this.compare(a.lastModified, b.lastModified, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
